import { Component, inject, Input } from '@angular/core';
import { AssetService } from '../../../../../services/asset.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalableDigbi } from '../../../../../models/modalable-digbi';

@Component({
    selector: 'app-digbi-modal',
    templateUrl: './digbi-modal.component.html',
    styleUrls: ['./digbi-modal.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        AssetPipe
    ]
})
export class DigbiModalComponent extends ModalComponent {
    @Input() declare modalable: ModalableDigbi;
    protected assetService = inject(AssetService);
    protected applicationStateService = inject(ApplicationStateService);

    getId(): string {
        return this.modalable.getModalId();
    }
}
